export class ChangeSummaryEntry {
    entityType: string;
    entityIds: number[];
}
